import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xb2d5ZWp4MCB7CiAgd2lkdGg6IDEwM3B4OwogIGhlaWdodDogNDRweDsKICBwb3NpdGlvbjogcmVsYXRpdmU7Cn0';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xb2d5ZWp4MSB7CiAgd2lkdGg6IDEwM3B4Owp9';
export var wrapperStyle = '_1ogyejx0';
export var svgStyle = '_1ogyejx1';